import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { ErrorService } from './error.service';
import { CORE_MESSAGES_SERVICE } from '../../tokens';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  errorService = inject(ErrorService);
  notifier = inject(CORE_MESSAGES_SERVICE);

  handleError(error: Error | HttpErrorResponse) {
    let errorName = '';
    let message = '';
    let stackTrace = '';

    if (error instanceof HttpErrorResponse) {
      // Server error
      if (error.status === 401) {
        console.log('handleError 401');
        return;
      } else if (error.status === 403) {
        message = 'base.error.notPermission';
      } else if (error.status === 504) {
        message = 'base.error.unexpectedError';
      } else {
        message = this.errorService.getServerErrorMessage(error);
      }

      errorName = this.errorService.getServerErrorName(error);
      stackTrace = this.errorService.getServerErrorStackTrace(error);
    } else {
      // Client Error
      errorName = 'ClientError';
      message = this.errorService.getClientErrorMessage(error);
      stackTrace = this.errorService.getClientStackTrace(error);
    }

    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(message)) {
      // check for site updates
      this.notifier.showWarning('Есть обновление, перезагрузите страницу, пожалуйста!');
    } else {
      this.notifier.showError(message);
    }

    // logger.logError(errorName, message, stackTrace);
    console.error(error);
  }
}
